<template>
  <div>
    <div style="padding: 10px;font-weight: bold">
      疫情防控信息填报
    </div>
    <!--    来源地址-->
    <van-field
      required
      readonly
      clickable
      name="FFromArea"
      :value="ADvalue"
      label="来源地地址"
      placeholder="点击选择省市区"
      @click="showFA = true"
      :rules="[{ required: true, error: '' }]"
    />
    <van-popup v-model="showFA" position="bottom">
      <van-area
        :area-list="areaList"
        @confirm="onConfirmAD"
        @cancel="showFA = false"
      />
    </van-popup>
    <!--    来新区时间-->
    <van-field
      required
      readonly
      clickable
      name="FCTime"
      :value="datevalue"
      label="来新区时间"
      placeholder="点击选择日期"
      @click="showCalendar = true"
      :rules="[{ required: true, error: '' }]"
    />
    <van-calendar v-model="showCalendar" @confirm="onConfirmDate" :min-date="minDate"/>
    <!--乘坐交通方式-->
    <van-field
      required
      readonly
      clickable
      name="FTraffic"
      :value="valueJT"
      label="交通方式"
      placeholder="点击选择乘坐交通方式"
      @click="showPicker = true"
      :rules="[{ required: true, error: '' }]"
    />
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirmJT"
        @cancel="showPicker = false"
      />
    </van-popup>
    <!--    交通方式详情-->
    <van-field
      required
      v-model="FTrafficXQ"
      name="FTrafficXQ"
      label="交通方式详情"
      placeholder="请输入车次/座位号/航班号或车牌号"
      :rules="[{ required: true, error: '请填写用户名' }]"
    />
    <!--    新区居住地-->
    <van-field
      required
      v-model="FXQArea"
      name="FXQArea"
      label="新区居住地"
      placeholder="精确到村小区酒店的楼/单元/房间号等"
      :rules="[{ required: true, error: '新区居住地' }]"
    />
    <!--    企业负责人-->
    <van-field
      required
      v-model="FFZUserName"
      name="FFZUserName"
      label="来访人员所在单位负责人"
      placeholder="来访人员所在单位负责人"
      :rules="[{ required: true, error: '企业负责人' }]"
    />
    <!--    负责人电话-->
    <van-field
      required
      v-model="FFZPhone"
      name="FFZPhone"
      label="负责人电话"
      placeholder="负责人电话"
      :rules="[{ pattern, error: '负责人电话',message:'电话格式错误' }]"
    />
    <!--    备注-->
    <van-field
      v-model="FRemark"
      name="FRemark"
      label="备注"
      placeholder="备注"
    />
    <!--健康信息-->
    <van-field name="FZhenDuan" label="" required :rules="[{ required: true, message: '请选择一个按钮' }]">
      <template #input>
        <van-radio-group v-model="radio" direction="horizontal">
          14天内是否被诊断为新冠肺炎确诊患者、疑似患者、阳性感染者或从境外疫情高发地区返回或曾有发热、持续干咳、乏力症状：
          <van-radio name="是">是</van-radio>
          <van-radio name="否">否</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <van-field name="FJieChu" label="" required :rules="[{ required: true, message: '请选择一个按钮' }]">
      <template #input>
        <van-radio-group v-model="radio2" direction="horizontal">
          14天内是否与疫情中高风险地区人员、有发热或呼吸道症状的人员、境外返回人员有接触史：
          <van-radio name="是">是</van-radio>
          <van-radio name="否">否</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <van-field name="FConfirm" label="" required :rules="[{ required: true, message: '请勾选本条内容' }]">
      <template #input>
        <van-checkbox v-model="checkbox" shape="square">
          <div>本人承诺遵守当地和本单位疫情防控的有关规定，以上内容属实，如隐瞒、虚报，本人承担一切法律责任或相应后果。</div>
        </van-checkbox>
      </template>
    </van-field>
  </div>

</template>

<script>
  import AeraInfo from '../api/Area.js'

  export default {
    name: 'COVID',
    data () {
      return {
        ADvalue: '',
        showFA: false,
        areaList: AeraInfo, // 数据格式见 Area 组件文档

        datevalue: '',
        showCalendar: false,
        minDate: new Date(1990, 0, 1),

        valueJT: '',
        columns: ['自驾车', '客车', '火车', '飞机', '轮渡', '点对点定制化运输', '其他'],
        showPicker: false,

        FTrafficXQ: '',
        FXQArea: '',
        FFZUserName: '',
        FFZPhone: '',
        pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
        FRemark: '',

        radio: '',
        radio2: '',
        checkbox: false,
      }
    },
    components: {},
    props: [
      'COVIDList'
    ],
    watch: {
      COVIDList: {
        // FXQArea: this.COVIDList.FXQArea,
        // ADvalue: this.COVIDList.FFromArea,
        // datevalue: this.COVIDList.FCTime,
        // valueJT: this.COVIDList.FTraffic,
        // FTrafficXQ: this.COVIDList.FTrafficXQ,
        // FFZUserName: this.COVIDList.FFZUserName,
        // FFZPhone: this.COVIDList.FFZPhone,
        // FRemark: this.COVIDList.FRemark,
        // radio: this.COVIDList.FZhenDuan,
        // radio2: this.COVIDList.FJieChu
      }
    },
    mounted () {
      setTimeout(()=>{
        this.FXQArea = this.COVIDList.FXQArea
        this.ADvalue = this.COVIDList.FFromArea
        this.datevalue = this.COVIDList.FCTime
        this.valueJT = this.COVIDList.FTraffic
        this.FTrafficXQ = this.COVIDList.FTrafficXQ
        this.FFZUserName = this.COVIDList.FFZUserName
        this.FFZPhone = this.COVIDList.FFZPhone
        this.FRemark = this.COVIDList.FRemark
        this.radio = this.COVIDList.FZhenDuan
        this.radio2 = this.COVIDList.FJieChu
        this.checkbox = true
      },500)

      // console.log(this.FXQArea)
    },
    methods: {
      onConfirmAD (values) {
        this.ADvalue = values
          .filter((item) => !!item)
          .map((item) => item.name)
          .join('/')
        this.showFA = false
      },
      onConfirmDate (date) {
        this.datevalue = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
        this.showCalendar = false
      },
      onConfirmJT (value) {
        this.valueJT = value
        this.showPicker = false
      },

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/COVID.vue